import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  button: { padding: 5 },
});

export default useStyles;
